import React from 'react'
import PropTypes from 'prop-types'

import Button from './Button'
import { VARIANT } from './constants'

/**
 * @see Extends [`Button`](#/Components/Button?id=button-1) by setting relevant `variant`
 */
const OutlinedButton = ({ children, ...rest }) => (
  <Button {...rest} variant={VARIANT.OUTLINED}>
    {children}
  </Button>
)

OutlinedButton.propTypes = {
  children: PropTypes.node.isRequired,
}

OutlinedButton.displayName = 'OutlinedButton'

export default OutlinedButton
